import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { QuestionType } from '@src/app/shared/enums/QuestionType.enum';

@Injectable({
  providedIn: 'root'
})
export class QuestionTypeService {
  constructor(public translate: TranslateService) { }

  getQuestionTypeOptions(): { label: string; value: QuestionType }[] {
    return [
      {
        label: this.translate.instant('SURVEYS_CREATE.QUESTION_TYPE_FIXED_VALUES'),
        value: QuestionType.FIXED_VALUES
      },
      {
        label: this.translate.instant('SURVEYS_CREATE.QUESTION_TYPE_TEXT'),
        value: QuestionType.TEXT
      },
      {
        label: this.translate.instant('SURVEYS_CREATE.QUESTION_TYPE_NUMBER'),
        value: QuestionType.NUMBER
      }
    ];
  }
}
